<div class="container my-3">
  <!-- <h1 class="mb-3">Edit Element Model</h1> -->
  <form #form="ngForm" (ngSubmit)="updateModel()" class="mt-4">
    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="name" class="form-label">Manufacturer</label>
      </div>
      <div class="col-sm-4">
        <select
          style="float: left"
          class="form-select border border-dark"
          [(ngModel)]="modelDetails.ManufacturerId"
          name="manufacturerId"
          #manufacturerId="ngModel"
        >
          <option
            *ngFor="let manufacturer of manufacturers"
            [value]="manufacturer.Id"
            [selected]="manufacturer.Id === modelDetails.ManufacturerId"
          >
            {{ manufacturer.Name }}
          </option>
        </select>
        <div
          *ngIf="
            modelDetails.ManufacturerId === null &&
            (manufacturerId.touched || manufacturerId.dirty)
          "
          style="text-align: left; color: gray"
        >
          This field is required
        </div>
        <div
          *ngIf="ManufacturerIdError"
          class="text-danger"
          style="text-align: left; color: gray"
        >
          This field is required
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="name" class="form-label">Name</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          style="float: left"
          class="form-control border border-dark"
          id="name"
          name="name"
          [(ngModel)]="modelDetails.Name"
        />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="name" class="form-label">Type</label>
      </div>
      <div class="col-sm-4">
        <select
          class="form-select border border-dark"
          style="float: left"
          [(ngModel)]="modelDetails.Type"
          name="Type"
          #EditModeltype="ngModel"
        >
          <option [ngValue]="null" disabled>Select Type</option>
          <option [ngValue]="0">SWRO</option>
          <option [ngValue]="1">BWRO</option>
        </select>
        <div
          *ngIf="
            modelDetails.Type === null &&
            (EditModeltype.touched || EditModeltype.dirty)
          "
          style="text-align: left; color: gray"
        >
          This field is required
        </div>
        <div
          *ngIf="TypeError"
          class="text-danger"
          style="text-align: left; color: gray"
        >
          This field is required
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="name" class="form-label">Membrane Area</label>
      </div>
      <div class="col-sm-4">
        <input
          type="number"
          style="float: left"
          class="form-control border border-dark"
          id="contactName"
          name="contactName"
          [(ngModel)]="modelDetails.Ma"
        />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="name" class="form-label">TCFA</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          style="float: left"
          class="form-control border border-dark"
          id="tcfa"
          name="tcfa"
          [(ngModel)]="modelDetails.Tcfa"
        />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="name" class="form-label">TCFB</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          style="float: left"
          class="form-control border border-dark"
          id="tcfb"
          name="tcfb"
          [(ngModel)]="modelDetails.Tcfb"
        />
      </div>
    </div>

  
    <div style="min-height: 50px"></div>
    <div class="row">
      <div class="col-sm-2" style="text-align: right">
        <button type="submit" class="btn custom-buttons-btn m-3">Update</button>
      </div>

      <div class="col-sm-2" style="text-align: left">
        <button
          type="button"
          class="btn custom-delete-btn m-3"
          (click)="deleteModel(modelDetails.Id)"
        >
          Delete
        </button>
      </div>
    </div>
  </form>
</div>
